import {useTranslation} from 'react-i18next';
import styles from './styles.module.css';
import scanGuide from 'assets/img/scan-kiosko.gif';
import {BoxInfo, NavigationStatus} from '@guestapp/ui';

function ScanDocument() {
  const {t} = useTranslation();
  return (
    <div className={styles.wrapper}>
      <div className={styles.scanGuideBox}>
        <img src={scanGuide} alt="Scan Guide" width={327} height={327} />
      </div>
      <div className={styles.scanInstructions}>
        <span className={styles.scanInstructionsTitle}>{t('instructions')}</span>
        <div className={styles.scanInstructionsList}>
          <div className={styles.scanInstructionsListItem}>
            {t('place_passport_facing_down')}
          </div>
          <div className={styles.scanInstructionsListItem}>{t('tap_scan_document')}</div>
        </div>
        <BoxInfo
          text={t('make_sure_the_document_properly_lies_flat')}
          type={NavigationStatus.information}
        />
      </div>
    </div>
  );
}

export {ScanDocument};
